type AppEnv = 'development' | 'test' | 'production'

const validAppEnvs = new Set<AppEnv>(['development', 'test', 'production'])

function normalizeAppEnv(value: string | undefined): AppEnv {
  if (value && validAppEnvs.has(value as AppEnv)) {
    return value as AppEnv
  }

  if (import.meta.env.DEV) {
    return 'development'
  }

  return 'production'
}

function toBoolean(value: string | undefined): boolean {
  return value === 'true'
}

const appEnv = normalizeAppEnv(import.meta.env.VITE_APP_ENV)

export const appConfig = {
  env: appEnv,
  isDevelopment: appEnv === 'development',
  isTest: appEnv === 'test',
  isProduction: appEnv === 'production',
  title: import.meta.env.VITE_APP_TITLE || '数据大屏',
  apiBaseUrl: import.meta.env.DEV
    ? '/api'
    : import.meta.env.VITE_API_BASE_URL || '/api',
  enableDebugPanel: toBoolean(import.meta.env.VITE_ENABLE_DEBUG_PANEL),
  buildTime: import.meta.env.VITE_BUILD_TIME || '',
} as const
